import React from 'react';
import {Tag} from 'antd';
import utils from '../../../utils';
import fetch from '../../fetch';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号',
        width: 80
    },
    {
        key: 'orgName',
        label: '部门名称',
        width: 250
    },
    {
        key: 'statusDesc',
        label: '填写状态',
        render : (val)=> {
            if(val == '已填写'){
                return <Tag color='green'>{val}</Tag>
            }else if(val == '未填写'){
                return <Tag color='red'>{val}</Tag>
            }
        },
    },
    {
        key: 'schoolStudentNum',
        label: '在校生人数',
        width: 100
    },
    {
        key: 'graduateStudentNum2023',
        label: '应届（2023）毕业生人数',
        width: 180
    },
    {
        key: 'graduateStudentNum2022',
        label: '2022届毕业生人数',
        width: 160
    },
    {
        key: 'graduateStudentNum2021',
        label: '2021届毕业生人数',
        width: 160
    },
    {
        key: 'graduateStudentNum2020',
        label: '2020届毕业生人数',
        width: 160
    },
    {
        key: 'teacherNum',
        label: '教职工人数',
        width: 120
    },
    {
        key: 'termName',
        label: '学期',
        width: 140
    },
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('survey/statistics/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code === 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data || []).length ? '' : '暂无数据...'
        }))
    )
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    columns,
    querySearch
}